import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { GlobalSessionComponent } from 'src/app/components/global-session/global-session.component';
import { DataFlightService, HttpService, SessionService, UtilityService } from 'src/app/services';


@Component({
  selector: 'app-flight-result',
  templateUrl: './flight-result.component.html',
  styleUrls: ['./flight-result.component.scss']
})
export class FlightResultComponent implements OnInit {
  trip_type;
  tripType;
  urlValue;
  roundTripDate;
  search_request;
  tripValur: any = [];
  internationForm: FormGroup;
  // Trip Active
  oneWayTrip: boolean = false;
  roundWayTrip: boolean = false;
  internationRoundTrip: boolean = false;
  disableSessionTimeout: boolean = false; // Add this line to initialize the flag
  private sessionTimeoutStarted = false;  // Add this flag to ensure the timer only starts once
private remainingTime: number; 

private sessionTimeoutId: any; // Store timeout ID
  booking_class: any;


  constructor(private route: ActivatedRoute, public util: UtilityService, private router: Router, public fb: FormBuilder, private session: SessionService, public dialog: MatDialog, private flightData: DataFlightService) {
    this.trip_type = JSON.parse(localStorage.getItem('flight_search')!);
    
    if(this.trip_type === null) {
      this.router.navigate(['../../flights'], { relativeTo: this.route })
    }

    if (this.trip_type.trip_selected === 0) {
      this.urlValue = this.trip_type;
      this.search_request = this.trip_type.search_request;
    } else if (this.trip_type.trip === 1) {
      this.urlValue = this.trip_type.one_way;
      this.roundTripDate = this.trip_type.round_way.onwarddate;
      this.search_request = this.trip_type.one_way.search_request;
    } if(this.trip_type.trip_selected === 1) {
      this.urlValue = this.trip_type;
      this.roundTripDate = this.trip_type.search_request.returndate;
      this.search_request = this.trip_type.search_request;
    }
    
    const originCountryCode = this.search_request.origin.country_code;
    const destinationCountryCode = this.search_request.destination.country_code;
    
    if (originCountryCode === 'IN' && destinationCountryCode === 'IN') {
      this.tripType = 'd';
    } else {
      this.tripType = 'i';
    }

    // console.log(this.trip_type.one_way.search_request, "triptype");
    if(this.trip_type.trip_selected === 0) {
      this.oneWayTrip = true;
      this.UrlBindingInfo();
      // this.router.navigate(['one-way'], { relativeTo: this.route });
    } else if (this.trip_type.trip_selected === 1) {
      this.UrlBindingInfo();  
      this.internationRoundTrip = true;
    } else if(this.trip_type.trip === 1) {
      if(this.tripType !== "i") {
        this.UrlBindingInfo(); 
        this.roundWayTrip = true;
        // this.router.navigate(['round-way'], { relativeTo: this.route });
      } else if(this.tripType === "i") {
        this.internationRoundTrip = true;
        this.internationForm = this.fb.group({
          credentials: this.util.getApiRequestCredentials(),
          country_code: this.trip_type.trip_type,
          trip_selected:this.trip_type.one_way.trip_selected,
          destination: this.trip_type.one_way.destination,
          numadults :  this.trip_type.one_way.numadults,
          numchildren :  this.trip_type.one_way.numchildren,
          numinfants : this.trip_type.one_way.numinfants,
          onwarddate: this.trip_type.one_way.onwarddate,
          origin: this.trip_type.one_way.origin,
          prefcarrier: this.trip_type.one_way.prefcarrier,
          prefclass: this.trip_type.one_way.prefclass,
          returndate: this.trip_type.round_way.onwarddate,
          numresults: this.trip_type.one_way.numresults,
          search_request: this.trip_type.one_way.search_request,
        });
        localStorage.setItem('flight_search', JSON.stringify(this.internationForm.value)!)
        this.UrlBindingInfo();
      }
    } else if(this.trip_type.trip === 2) {
      this.router.navigate(['multi-city'], { relativeTo: this.route });
    }

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.clearSessionTimeout();
      }
    });

    this.setupSessionTimeout();
  }

  ngOnInit(): void {
  }

  UrlBindingInfo() {
    // const booking_class = JSON.parse(localStorage.getItem('booking_class')!);
    this.flightData.getBookingClasses().subscribe(
      data => { 
        this.booking_class = data; 
        const selectedBookingClass = this.booking_class.find((item: any) => item.class === this.urlValue.prefclass);
        let prefClassId = null;
        if (selectedBookingClass) {
          prefClassId = selectedBookingClass.id;
        }
        let resultUrl: string;
        if (this.roundTripDate) {
          resultUrl = `/${this.tripType}/${prefClassId}/${this.urlValue.numadults},${this.urlValue.numchildren},${this.urlValue.numinfants};${this.urlValue.origin}-${this.urlValue.destination}/${this.urlValue.onwarddate}/${this.roundTripDate}`;
        } else {
          resultUrl = `/${this.tripType}/${prefClassId}/${this.urlValue.numadults},${this.urlValue.numchildren},${this.urlValue.numinfants};${this.urlValue.origin}-${this.urlValue.destination}/${this.urlValue.onwarddate}`;
        }
        const decodedUrl = (resultUrl);
        this.navigateToDecodedUrl(decodedUrl);
      },
      err => { this.util.errorMessage(err); }
    );
  }
  
  navigateToDecodedUrl(decodedUrl: string): void {
    this.router.navigate([], { relativeTo: this.route, fragment: (decodedUrl), preserveFragment: false});
  }


 private setupSessionTimeout(): void {
    if (this.sessionTimeoutStarted) {
      return;
    }

    this.sessionTimeoutStarted = true;
    this.session.trackUserActivity(); 
    const logoutTimeout = this.session.getLogoutTimeout();
    
    this.sessionTimeoutId = setTimeout(() => {
      this.dialog.open(GlobalSessionComponent, {
        panelClass: 'session-dialog-container',
        width: '100%',
        maxWidth: '520px',
        disableClose: true,
      });
    }, logoutTimeout);
  }

  private clearSessionTimeout(): void {
    const continueRoutes = [
      'search',
      '/_Insurance',
      '/_Passenger',
      '/_add-ons',
      '/_Payment',
    ];
  
    const currentUrl = this.router.url;
    if (continueRoutes.some(route => currentUrl.includes(route))) {
      return;
    }
    if (this.sessionTimeoutId) {
      clearTimeout(this.sessionTimeoutId);
      this.sessionTimeoutId = null; // Reset ID
    }
    this.sessionTimeoutStarted = false; 
  }

  
  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    const scrollValue = window.scrollY || window.pageYOffset;
    const bodyElement = document.querySelector('body');
    if (scrollValue > 110) {
      bodyElement?.classList.add('scroll-top');
      bodyElement?.setAttribute('id', 'top');
    } else {
      bodyElement?.classList.remove('scroll-top');
      bodyElement?.removeAttribute('id');
    }
  }

  scrollToTop () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  // serializeQueryParams(params: any): string {
  //   const encodedParams = Object.keys(params)
  //     .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
  //     .join('&');

  //   return encodedParams;
  // }
}
